import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GenerateLlmCustomizationMutation,
  GenerateLlmCustomizationMutationVariables,
} from "./GenerateLLMCustomization.generated";

const GENERATE_LLM_CUSTOMIZATION: TypedDocumentNode<
  GenerateLlmCustomizationMutation,
  GenerateLlmCustomizationMutationVariables
> = gql`
  mutation GenerateLLMCustomization(
    $createLlmCustomizationInput: CreateLLMCustomizationsInput!
  ) {
    generateLlmCustomizations(
      createLlmCustomizationInput: $createLlmCustomizationInput
    ) {
      ok
      result
    }
  }
`;

export default GENERATE_LLM_CUSTOMIZATION;
